import { Observable } from 'rxjs';
import { OrdersCompensationModelKeys } from '../models/orders-compensation.model';

export abstract class OrdersCompensationRepository {
    abstract getOrdersCompensation<T>(
        config: OrdersCompensationModelKeys,
    ): Observable<T>;
}
